import template from './tableGridCheckboxCell.html';
import controller from './tableGridCheckboxCell.controller';

let tableGridCheckboxCellComponent = () => {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      row: '=',
      columnName: '@',
      metaData: '=',
      options: '=',
      rowsSelected: '='
    },
    template,
    controller: ['$scope', function($scope) {
      let vm = this
      vm.toggleCheckbox = function(){
        $scope.$emit('checkboxChange', { checklistValue: $scope.vm.checklistValue, isChecked: $scope.vm.isChecked })
      }
    }],

    controllerAs: 'vm',
    link: (scope,elem,attrs,ctrl) => {
      scope.vm = scope;
      scope.vm.checklistValue = scope.vm.row.id;
      scope.vm.isDisabled = scope.vm.row.isDisabled;
      scope.vm.toolTip = scope.vm.row.toolTip;
      scope.vm.toggleCheckbox = ctrl.toggleCheckbox; 
    }
  };
};

export
default tableGridCheckboxCellComponent;



// WEBPACK FOOTER //
// ./app/components/tableGridCheckboxCell/tableGridCheckboxCell.component.js